module.exports = __webpack_public_path__ + "img/info-6.6a5fbf0c.svg";